import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

export const ClientAddOrEditInitializer = (props: {
  onClose: (obj: { isSaved: boolean }) => void;
  accessedFrom: 'clients.client_list' | 'clients.client_list_empty_state';
}): Initializer => {
  const node = getOrAppendChild({ id: 'clients-add', parentNode: document.body });

  const destroy = () => ReactDOM.unmountComponentAtNode(node);
  const onClose = ({ isSaved }) => {
    props.onClose({ isSaved });
    destroy();
  };

  return {
    destroy: () => ReactDOM.unmountComponentAtNode(node),
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="ClientAddOrEdit"
          props={{
            onClose,
            notifyFn: Wahanda.ToastNotifications.sendMessage,
            accessedFrom: props.accessedFrom,
          }}
        />,
        node,
      );
    },
  };
};
